import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import autobind from 'autobind-decorator'
import signatureDataFragment from '../../../../../../Settings/Signature/signatureDataFragment'

@withGraphQL(gql`
  query getMySignature {
    me {
      signature {
        _id
        image {
          url
        }
      }
    }
  }
`)
@withGraphQL(gql`
query getSignature ($signatureId: ID) {
  signature (signatureId: $signatureId) {
    _id
    image {
      url
    }
  }
}`)
@withGraphQL(gql`
  query getMySignatures {
    me {
      ...signatureData
    }
  }
  ${signatureDataFragment}
`)
export default class Signature extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
    me: PropTypes.func,
    signature: PropTypes.object
  }

  @autobind
  async setSignature(selSignatureId) {
    const signatureId = await this.props.me.signature._id
    await this.props.onChange(signatureId)
    console.warn('setSignature: ', signatureId, 'is set')
  }
  async getSignature() {
    global.onCloseSignature.push(this.setSignature)
    const signatureId = await global.getSelSignature()
    return signatureId
  }

  render() {
    if (this.props.me.signature){
      console.log('Datos ', this.props.me.signature)
      const signature = this.props.me.signature.image.url
      return (
        <div className={styles.container}>
          <div
            className={styles.signature}
            style={{cursor: 'pointer', backgroundImage: `url(${signature})` }}
            onClick={() => this.getSignature()}
          />
        </div>
      )
    } else {
      return (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => global.openSignature()}
        >
          {` Selecciona una firma `}
        </span>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Menu/Value/Signature/index.js